// extracted by mini-css-extract-plugin
export default {"login-register-from":"oPpF5OYtzIkCySUrrT_i","common_bganimation":"IbcrGiFjW0rBMAZL3Bhn"};